import React from 'react';
import { LazySection } from './LazySection';
export function Transformacion() {
  return <LazySection className="bg-cream !py-[80px] md:!py-[100px]" data-id="element-365">
      <div className="container-wide" data-id="element-366">
        <div className="text-center" data-id="element-367">
          <span className="eyebrow" data-id="element-368">Lo que realmente cambia</span>
        </div>
        <h2 className="text-[clamp(32px,4.8vw,46px)] text-center mb-4" data-id="element-369">
          Cuando separás <em data-id="element-370">lo tuyo</em> de <em data-id="element-371">lo heredado</em>…
        </h2>
        <p className="text-center text-ink-soft text-[17px] max-w-[660px] mx-auto mb-[50px]" data-id="element-372">
          No se trata de que todo se arregle mágicamente. Se trata de que, por
          primera vez, podés ver qué estás eligiendo vos y qué estás
          obedeciendo.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-[960px] mx-auto" data-id="element-373">
          {[{
          before: 'Repetir relaciones que te lastiman',
          after: 'Ver el patrón antes de entrar — y elegir distinto desde la primera señal.'
        }, {
          before: 'Sentir culpa cuando te va bien',
          after: 'Recibir amor, dinero y logros sin la incomodidad de "no me lo merezco".'
        }, {
          before: 'Cargar un peso sin saber por qué',
          after: 'Distinguir qué emociones son tuyas y soltar las que no te pertenecen.'
        }, {
          before: 'Autosabotearte sin entender nada',
          after: 'Identificar el origen del freno — y tener una herramienta concreta para desactivarlo.'
        }, {
          before: 'Transmitirles a tus hijos lo mismo',
          after: 'Ser la generación que corta el ciclo — el regalo más grande que podés darles.'
        }, {
          before: 'Mirarte al espejo y ver a tu madre',
          after: 'Mirarte al espejo y verte a vos — empezando a escribir tu propia historia.'
        }].map((item, i) => <div key={i} className="bg-white rounded-[14px] p-6 md:px-6 md:py-6 border-l-[3px] border-l-gold shadow-sm" data-id="element-374">
              <div className="text-[13px] text-ink-soft mb-2 line-through opacity-55" data-id="element-375">
                {item.before}
              </div>
              <div className="font-serif text-[17px] text-ink leading-[1.4]" data-id="element-376">
                {item.after.includes('patrón') ? <>
                    Ver el <span className="highlight-keyword" data-id="element-377">patrón</span>{' '}
                    antes de entrar — y elegir distinto desde la primera señal.
                  </> : item.after.includes('origen') ? <>
                    Identificar el{' '}
                    <span className="highlight-keyword" data-id="element-378">origen</span> del freno
                    — y tener una herramienta concreta para desactivarlo.
                  </> : item.after}
              </div>
            </div>)}
        </div>
      </div>
    </LazySection>;
}